/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
import PercentageBar from 'components/shared/percentagebar/percentagebar'
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/content/shared/questionset/text2/answer/answer_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});

// return <Text2Answer id={this.props.answer.id} text={this.props.answer.text} predictionPercentage={this.props.predictionPercentage} barCoefficient={this.props.barCoefficient} isCorrect={this.props.answerStatus.isCorrect} isClicked={this.isSelected()} isResult={this.isResult()} />;


/* ========== ~~~~~~~~~~ TEXT 2 ANSWER ~~~~~~~~~~ ========== */
// STATELESS FUNCTIONAL COMPONENT
// used to create markup structure and render UI
// doesn't need all the lifecycle functions attached
class Text2Answer extends Component {

    constructor(props) {
        super(props);
        // state to store FontSize of the answer.
        this.state = {fontSize: 'standard'};
        this.answerEl = null;
        this.availableSizes = ['standard', 'medium', 'large'];
    }

    componentDidMount() {
        this.adjustFontSize();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.text !== this.props.text)
            this.adjustFontSize();
    }

    adjustFontSize() {
        let quesSize = 'standard';
        this.setState({
            quesSize: quesSize
        }, () => this.readjustFontSize())
    }

// the current height and width of the question elements are grabbed and checked here and font size is adjusted accordingly.
// Now we have the exact height of question element and so we can adjust the font size accordingly.
// in very rare cases, this function will be called more than 2 times. So no loop here.
    readjustFontSize() {
        let ansSize = this.state.fontSize;
        const currAnsSizeIndex = this.availableSizes.indexOf(ansSize);
        if (this.answerEl && (this.getContainerDimensions().height - this.getElementInContainerDimensions().height) < 0 && ansSize !== 'large') {
            ansSize = this.availableSizes[currAnsSizeIndex + 1] ? this.availableSizes[currAnsSizeIndex + 1] : ansSize;
            this.setState({
                fontSize: ansSize
            }); // again calling it just in case to see if fonts need more readjustment. Wont be called unless font needs resizing.
        }
    }

    getContainerDimensions() {
        const el = this.answerEl;
        let height = el.clientHeight;
        return {width: el.clientWidth, height: height};
    }

    getElementInContainerDimensions() {
        const el = this.answerEl.childNodes[1];
        return {width: el.clientWidth, height: el.clientHeight};
    }

    render() {
        return(
            <span className={`${sheet.classes.uniqueanswer} uniqueanswer`}>
                <span className={`${sheet.classes.desc} desc`} ref={span => this.answerEl = span}>
                    <span className={`icon`}></span>
                    <span className={`text ${this.state.fontSize}`}>{this.props.text}</span>
                </span>
                {this.props.isResult ? <PercentageBar type={`horizontal`} barCoefficient={this.props.barCoefficient}
                                                      amount={`${this.props.predictionPercentage}`}
                                                      isClicked={this.props.isClicked}
                                                      isCorrectAnswer={this.props.isCorrectAnswer}/> : null}
            </span>
        )
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Text2Answer;
